import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton } from '../../../Components/Utils/Buttons';
import SearchBar from '../../../Components/Utils/SearchBar';

import { GetAccess } from '../../../Components/Utils/roles';
import Breadcrumb from '../../../Components/Utils/Breadcrumb';

const ReportLayout =  (
    {
      getData=() => {},
      setSearchQuery=()=>{},
      CreateAccess= false,
      ImportAccess= false,
      setOpen=()=>{},
      children,
      onCreateClick,
      searchValue="",
      searchFun=()=>{},
      isFilter=false,
      setFilterOpen=()=>{},
      newfilter=false,
      ClearFilter=()=>{},
      neededSearch=false,
      showproject=true,
      isCard=true,
      setViewMode=()=>{},
          viewMode="",
          ExportAccess=true,
      setOpenExport=()=>{},
  
  
  
  }
  ) => {
    let {pathname} = useLocation()
    const [module,setModule] = useState("")
    const navigate = useNavigate();
           
      
      
     
  
          const [screenSize, setScreenSize] = useState({
            width: window.innerWidth,
          });
        
          useEffect(() => {
            const handleResize = () => {
              setScreenSize({
                width: window.innerWidth,
              });
            };
        
            window.addEventListener("resize", handleResize);
        
            return () => {
              window.removeEventListener("resize", handleResize);
            };
          }, []);
    
    useEffect(() =>{
        if(pathname == `/report`){
            setModule("Report")
  
        }else {
          setModule("Invalid")
        }
    },[pathname])
  
    let LinkItem = [
        {
            label:"Report",
            link:`/report`,
            access:GetAccess('report_view'),
            
        },
       
       
    ];
  
   
  
  
  
    return(
      <div className=" w-full  h-full py-2 px-4 overflow-hidden">
              
              <div className="md:flex justify-between w-full my-2.5">
              <Breadcrumb
                    items={[
                     
                      { name: module },
                    ]}
                  />
  
             
  
  
  
  
  
              <div className=" flex justify-end items-center gap-3 ">
              <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
             
             {neededSearch &&  <SearchBar handleChange={searchFun}  value={searchValue}/>}
  
              </form>
             
              {/* {newfilter && (
    <>
                <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
                 {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
                                 {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />} */}
                  
  
                             </div>
              </div>
  
              <div className=" w-full  flex items-center gap-x-1 mt-1">
              {
                  LinkItem && LinkItem.map((item, i) => {
        const isActive = item?.link === pathname;
  
                      return(
                          <>
                           {
                              item.access && (
                                 <Link
                                                                                               to={item?.link}
                                                                                               key={item?.link}
                                                                                               className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                                 ${isActive 
                                                                                                   ? "bg-baseColor-primary text-white" 
                                                                                                   : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                                 }`}
                                                                                             >
                                                                                               {item?.label || ""} 
                                                                                             </Link>
                                                      // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                       )
                           }
                          </>
                      )
                  })
              }
          </div>
             
             
             
              <div className=" w-full h-[calc(100vh-165px)]  ">
                 {children} 
              </div>
              </div>
         
  )
  }
  

export default ReportLayout